/* eslint-disable import/no-default-export */
import React, { Suspense } from 'react';

import { connect } from 'react-redux';

import {
  OverlayType,
  OverlayContext,
} from 'app/gamma/src/modules/state/ui/overlay';
import { State } from 'app/gamma/src/modules/types';
import {
  getActiveOverlay,
  getOverlayContext,
  getCreateBoardOverlayLegacyTrackingOptions,
} from 'app/gamma/src/selectors/overlays';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ReduxProvider } from 'app/src/components/ReduxProvider';
import { SnowplowTrackingOptions } from 'app/gamma/src/components/create-board/props';

interface OverlaysProps {
  overlay: string | null;
  trackingOpts?: SnowplowTrackingOptions;
  context: OverlayContext;
}

const Overlays = ({ overlay, trackingOpts, context }: OverlaysProps) => {
  let component;

  const CreateBoardOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "create-board-overlay" */ './create-board-overlay'
    ),
  );

  const ClosedBoardsOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "closed-boards-overlay" */ './closed-boards-overlay'
    ),
  );

  const CreateTeamOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "gamma-create-team-overlay" */ './create-team-overlay'
    ),
  );

  const PlanSelectionOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "plan-selection-overlay" */ './plan-selection-overlay'
    ),
  );

  switch (overlay) {
    case OverlayType.CreateBoard: {
      const props = trackingOpts ? { trackingOpts } : {};
      component = <CreateBoardOverlay {...props} />;
      break;
    }
    case OverlayType.ClosedBoards:
      component = <ClosedBoardsOverlay source={context?.source} />;
      break;
    case OverlayType.CreateTeam:
      component = <CreateTeamOverlay />;
      break;
    case OverlayType.PlanSelection:
      component = context?.orgId && (
        <PlanSelectionOverlay orgId={context?.orgId} />
      );
      break;
    default:
      component = null;
  }

  return <Suspense fallback={null}>{component}</Suspense>;
};

const mapStateToProps = (state: State) => {
  return {
    overlay: getActiveOverlay(state),
    context: getOverlayContext(state),
    trackingOpts: getCreateBoardOverlayLegacyTrackingOptions(state),
  };
};

const Connected = connect(mapStateToProps)(Overlays);

const WithReduxProvider = () => {
  return (
    <ReduxProvider>
      <Connected />
    </ReduxProvider>
  );
};

export default WithReduxProvider;
